"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { initAnalytics, pageview } from "@/lib/analytics";

// Boots analytics client-side (no-op without a key / on demo hosts) and fires a
// pageview on each route change. Renders nothing.
export function PostHogProvider() {
  const pathname = usePathname();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    pageview();
  }, [pathname]);

  return null;
}
